module.exports = __webpack_public_path__ + "img/15.239f3322.png";